import React, { useState, useEffect } from 'react'
import { useDocuments } from 'contexts/documents'
import { useDragHandle } from 'hooks/drag-handle'
import { useDownload } from 'hooks/download'
import {
    image as imageExtensions,
    spreadsheet as spreadsheetExtensions,
    plaintext as plaintextExtensions
} from 'utilities/file'
import { Layout } from '../s'
import Content from 'modals/file-preview/content/preview'
import ResizeHandle from 'components/resize-handle'
import Details from './details'

const PreviewDocument = ({
    dokument = {},
    mode = 'view',
    setConfiguringSigning,
    setReviewingDocumentSigningStatus,
    previewAnother,
    removeAction,
    updatedAt,
    modal,
    salt
}) => {
    const { layout, resizeHandle, contentHeight, handleMouseDown } = useDragHandle()

    const [supported, setSupported] = useState(null)

    const {
        getDocumentPreviewUrl,
        getSignedDocumentPreviewUrl
    } = useDocuments()

    const {
        id,
        extension,
        signing
    } = dokument

    const getPreviewUrl = (signing?.status === 'closed') ?
        getSignedDocumentPreviewUrl :
        getDocumentPreviewUrl

    const path = getPreviewUrl(id)
    const { raw, file, objectUrl, download } = useDownload({ path })

    useEffect(() => {
        if([
            ...imageExtensions,
            ...spreadsheetExtensions,
            ...plaintextExtensions,
            'pdf'
        ].includes(extension)) {
            download()
        } else setSupported(false)
    }, [extension])

    useEffect(() => {
        file && setSupported(true)
    }, [file])

    salt = `${salt}:${id}:${extension}`

    return (
        <Layout
            style={{ '--content-height': `${contentHeight}%` }}
            ref={layout}>
            <Content
                supported={supported}
                file={file}
                objectUrl={objectUrl}
                raw={raw}
                extension={extension}
                salt={salt} />
            <ResizeHandle
                onMouseDown={handleMouseDown}
                ref={resizeHandle} />
            <Details
                dokument={dokument}
                mode={mode}
                file={file}
                setConfiguringSigning={setConfiguringSigning}
                setReviewingDocumentSigningStatus={setReviewingDocumentSigningStatus}
                previewAnother={previewAnother}
                removeAction={removeAction}
                dismiss={modal.dismiss}
                updatedAt={updatedAt}
                salt={salt} />
        </Layout>
    )
}

export default PreviewDocument